module.exports = __webpack_public_path__ + "static/media/powerpointZendy.c2c9ab9e.png";